import Row from './OrderDocumentsTableRow';
import { DocumentsLookupView } from '../../../orders/order';
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { BottomScrollListener } from '@ami/react/core';

const OrderDocumentsTable = ({
  documents,
  loading,
  onBottomScroll,
  onDownload,
  downloadingId,
  searched,
  searchOption
}) => {
  const rows = documents
    ? documents.map((doc) => (
        <Row
          document={doc}
          key={doc.fullDocumentId}
          onDownload={onDownload}
          downloadingId={downloadingId}
        />
      ))
    : [];
  const content = (
    <Fragment>
      {!loading && <Fragment>{rows}</Fragment>}
      {(loading || rows.length === 0) && (
        <tr>
          <td>
            {loading && (
              <span>
                Loading... <i className="fa fa-spin fa-spinner" />
              </span>
            )}
            {!loading && searched && searchOption === 1 && <span>No documents found</span>}
            {!loading && searched && searchOption === 2 && <span>Sorry, we are unable to locate your documents based off your PO #, please try searching by Serial # instead</span>}
            {!loading && !searched && (
              <span>Please enter a valid filter criteria and search</span>
            )}
          </td>
        </tr>
      )}
    </Fragment>
  );
  return (
    <table className="table table-striped table-hover table-mobile">
      <thead>
        <tr>
          <th>Document Name</th>
        </tr>
      </thead>
      <tbody>
        {onBottomScroll && (
          <BottomScrollListener onBottom={onBottomScroll}>
            {content}
          </BottomScrollListener>
        )}
        {!onBottomScroll && <Fragment>{content}</Fragment>}
      </tbody>
    </table>
  );
};

OrderDocumentsTable.propTypes = {
  documents: PropTypes.arrayOf(PropTypes.instanceOf(DocumentsLookupView)),
  loading: PropTypes.bool.isRequired,
  onBottomScroll: PropTypes.func,
  onDownload: PropTypes.func.isRequired,
  downloadingId: PropTypes.string,
};

export { OrderDocumentsTable };
